module.exports = __webpack_public_path__ + "img/5278.ff278aeb.jpg";